import HalogigTestimonials from './HalogigTestimonials';

export default HalogigTestimonials;

